import React from 'react';

import { List } from '../../components';
import { ListContainer } from '../../containers';
import { useRefreshPage } from '../../hooks/useRefreshPage';

import StockDeliveryListItem from './StockDeliveryListItem';

const StockDeliveryList = ({
	items,
	refetch,
	customProps,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	return (
		<List
			items={items}
			listItemComponent={StockDeliveryListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No stock deliveries found"
			autoScrollTop={true}
			showControls={true}
			removeTopMargin={true}
			customProps={customProps}
			assembler={[]}
		/>
	);
};

export default ListContainer(StockDeliveryList);
